export const advancedCommerceScope = {
  view: 'view',
  basket: 'basket',
  order: 'order',
};

export const advancedCommerceActions = {
  remove: 'remove',
  add: 'add',
};

const advancedCommerceTrack = (scope, action, data) => {
  if (typeof window.$g !== 'undefined') {
    window.$g.track({
      scope,
      action,
      data,
    });
  }
};

export const trackViewAdd = product => {
  if (product && product.productCode) {
    advancedCommerceTrack(advancedCommerceScope.view, advancedCommerceActions.add, {
      product_id: product.productCode?.toLowerCase(),
      quantity: 1,
    });
  }
};

const trackBasket = (product, action) => {
  const productIdentifier = product.baseId || product.productCode || product.id;
  if (product && productIdentifier) {
    advancedCommerceTrack(advancedCommerceScope.basket, action, {
      product_id: productIdentifier?.toLowerCase(),
      quantity: 1,
    });
  }
};

export const trackBasketAdd = product => {
  trackBasket(product, advancedCommerceActions.add);
};

export const trackBasketRemove = product => {
  trackBasket(product, advancedCommerceActions.remove);
};

let hasOrderTrackedInMemory = false;

export const trackOrderConfirmation = orderConfirmation => {
  if (!orderConfirmation || !orderConfirmation.code) {
    return;
  }

  if (hasOrderTrackedInMemory) {
    return;
  }
  hasOrderTrackedInMemory = true;

  const orderLines = orderConfirmation.entries.map(entry => ({
    product_id: entry.product.baseProduct?.toLowerCase(),
    product_sku: '',
    product_name: `${entry.product.name} ${entry.product.description}`,
    variant_id: entry.product.code,
    variant_sku: '',
    quantity: entry.quantity,
    unit_rrp: entry.basePrice.value,
    order_line_total: entry.totalPrice.value,
  }));

  const trackingData = {
    order_id: orderConfirmation.code,
    user_id: orderConfirmation.user?.uid || 'guest',
    order_total: orderConfirmation.totalPrice.value,
    order_tax: orderConfirmation.totalTax.value,
    order_shipping: orderConfirmation.deliveryCost.value,
    order_currency: orderConfirmation.totalPrice.currencyIso,
    order_lines: orderLines,
  };

  advancedCommerceTrack(advancedCommerceScope.order, advancedCommerceActions.add, trackingData);
};
